import { c as _c } from "react/compiler-runtime";
import React from 'react';
import { ExpandedNumberFormat } from 'shared/components/NumberFormat';
import { calculateRoas, calculateCostPerAction } from 'shared/utils';
import type { ReactTableRows, ReactTableColumn } from 'shared/reactTable/types';
import type { FormatIds } from '../numberFormat';
interface BasicFooterProps {
  rows: ReactTableRows;
  column: ReactTableColumn;
  currencyCode: string;
}
interface RoasFooterProps extends BasicFooterProps {
  revenueField: string;
  spendField: string;
  currencyCode: string;
}
interface CpaFooterProps extends BasicFooterProps {
  conversionField: string;
  spendField: string;
  currencyCode: string;
}
export const BasicRoasFooter = t0 => {
  const $ = _c(12);
  const {
    rows,
    column,
    currencyCode,
    revenueField,
    spendField
  } = t0;
  let t1;
  if ($[0] !== revenueField || $[1] !== rows || $[2] !== spendField) {
    let t2;
    if ($[4] !== revenueField) {
      t2 = (sum, row) => sum + (row.original[revenueField] as number);
      $[4] = revenueField;
      $[5] = t2;
    } else {
      t2 = $[5];
    }
    const totalRevenue = rows.reduce(t2, 0);
    let t3;
    if ($[6] !== spendField) {
      t3 = (sum_0, row_0) => sum_0 + (row_0.original[spendField] as number);
      $[6] = spendField;
      $[7] = t3;
    } else {
      t3 = $[7];
    }
    const totalSpend = rows.reduce(t3, 0);
    t1 = calculateRoas(totalRevenue, totalSpend);
    $[0] = revenueField;
    $[1] = rows;
    $[2] = spendField;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  const total = t1;
  const t2 = column.id as FormatIds;
  let t3;
  if ($[8] !== currencyCode || $[9] !== t2 || $[10] !== total) {
    t3 = <ExpandedNumberFormat value={total} id={t2} currencyCode={currencyCode} />;
    $[8] = currencyCode;
    $[9] = t2;
    $[10] = total;
    $[11] = t3;
  } else {
    t3 = $[11];
  }
  return t3;
};
export const BasicCpaFooter = t0 => {
  const $ = _c(12);
  const {
    rows,
    column,
    currencyCode,
    conversionField,
    spendField
  } = t0;
  let t1;
  if ($[0] !== conversionField || $[1] !== rows || $[2] !== spendField) {
    let t2;
    if ($[4] !== conversionField) {
      t2 = (sum, row) => sum + (row.original[conversionField] as number);
      $[4] = conversionField;
      $[5] = t2;
    } else {
      t2 = $[5];
    }
    const totalConversions = rows.reduce(t2, 0);
    let t3;
    if ($[6] !== spendField) {
      t3 = (sum_0, row_0) => sum_0 + (row_0.original[spendField] as number);
      $[6] = spendField;
      $[7] = t3;
    } else {
      t3 = $[7];
    }
    const totalSpend = rows.reduce(t3, 0);
    t1 = calculateCostPerAction(totalSpend, totalConversions);
    $[0] = conversionField;
    $[1] = rows;
    $[2] = spendField;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  const total = t1;
  const t2 = column.id as FormatIds;
  let t3;
  if ($[8] !== currencyCode || $[9] !== t2 || $[10] !== total) {
    t3 = <ExpandedNumberFormat value={total} id={t2} currencyCode={currencyCode} />;
    $[8] = currencyCode;
    $[9] = t2;
    $[10] = total;
    $[11] = t3;
  } else {
    t3 = $[11];
  }
  return t3;
};